module.exports = __webpack_public_path__ + "static/img/noimage.b6b1d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/noimage.jpg
// module id = 1ky7
// module chunks = 57